// Vendors
import React from 'react';
import { FormattedMessage } from 'react-intl';
// Components
import { LoaderComponent, ParagraphComponent } from '@openbank/ziniaweb-ui-components';
// Constants
import {
  KYC_BIZUM_FIRST_DESCRIPTION_PROPS,
  KYC_BIZUM_LOADER_PROPS,
  KYC_BIZUM_SECOND_DESCRIPTION_PROPS,
} from './constants/kyc-bizum.constants';
// Hooks
import { useKycBizumHook } from './hooks/kyc-bizum.hook';
// Styles
import { KycBizumLoaderStyled, KycBizumViewStyled } from './kyc-bizum.view.styled';
// Translations
import { KYC_BIZUM_DESCRIPTIONS } from './translations/kyc-bizum.translations';

const KycBizumView = (): React.JSX.Element => {
  useKycBizumHook();

  return (
    <KycBizumViewStyled>
      <KycBizumLoaderStyled>
        <LoaderComponent {...KYC_BIZUM_LOADER_PROPS} />
      </KycBizumLoaderStyled>
      <ParagraphComponent {...KYC_BIZUM_FIRST_DESCRIPTION_PROPS}>
        <FormattedMessage id={KYC_BIZUM_DESCRIPTIONS.description_01} />
      </ParagraphComponent>
      <ParagraphComponent {...KYC_BIZUM_SECOND_DESCRIPTION_PROPS}>
        <FormattedMessage id={KYC_BIZUM_DESCRIPTIONS.description_02} />
      </ParagraphComponent>
    </KycBizumViewStyled>
  );
};

export { KycBizumView };
